// extracted by mini-css-extract-plugin
module.exports = {"alertLoader":"Loading_alertLoader__3BkPa","loadingText":"Loading_loadingText__1krsL"};